import React from "react";
import { NavLink } from "react-router-dom";
import './Cile-Content.scss';

    const CileContent = () => {

        const cards = [
            {
                nome: "Banners",
                link: "/cile/conteudo/banners",
                icon: "fa-newspaper text-primary",
            },
            {
                nome: "Vídeos",
                link: "/cile/conteudo/videos?pagina=1&limite=10",
                icon: "fas fa-film text-purple",
            },
            {
                nome: "Resenhas",
                link: "/cile/conteudo/resenhas?pagina=1&limite=10",
                icon: "fas fa-book-reader text-danger",
            },
            {
                nome: "Livros",
                link: "/cile/conteudo/livros?pagina=1&limite=10",
                icon: "fas fa-columns text-success",
            },
        ]

        return (
            <div className="cile-remessas">
                <div className="row">
                    <div className="col-8 text-left">
                        <h2 className="title-1">Conteúdo</h2>
                    </div>
                    <div className="col-12 py-2">
                    <div className="row opcoes-home">
                        {cards.map((item) => {
                            return (
                                <div className="col-12 col-lg-4 py-3">
                                    <NavLink to={item.link}>
                                        <div className="card card-home">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className='col-12'>
                                                        <i className={`fas ${item.icon} fa-2x`}></i>
                                                    </div>
                                                    <div className='col-12 pt-2 nome-item'>
                                                        {item.nome}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            )
                        })}
                    </div>
                    </div>
                </div>
            </div>
        )
    }


export default CileContent;